import { render, staticRenderFns } from "./BulkUploadPage.vue?vue&type=template&id=55952d65&scoped=true"
import script from "./BulkUploadPage.vue?vue&type=script&lang=js"
export * from "./BulkUploadPage.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadPage.vue?vue&type=style&index=0&id=55952d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55952d65",
  null
  
)

export default component.exports